import { type FC } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import {
  getGetServicePointNotificationQueryKey,
  useAcknowledgementServicePointNotification,
  useGetServicePointNotification,
} from '@dhl/receiver-preference-api'

import { useGetProfile } from '~/profile/model/profile/hooks.js'
import { useGetServicepointDetails } from '~/servicepoints/hooks/useGetServicepointDetails.js'
import { useInteraction } from '../InteractionProvider.js'
import { CloserByServicePointModal } from './CloserByServicePointModal.js'
import { NewServicePointInAreaModal } from './NewServicePointInAreaModal.js'

export const NewServicePointInteraction: FC = () => {
  const { isOpen, onDismiss } = useInteraction()
  const { data: profile } = useGetProfile()
  const { mutateAsync: acknowledgeServicePointNotification } = useAcknowledgementServicePointNotification()
  const { data: servicePointNotification } = useGetServicePointNotification()
  const queryClient = useQueryClient()

  const matchingAddress = profile?.addresses?.find(
    (address) => address.addressId === servicePointNotification?.addressId
  )

  const { servicepoint, isLoading, typeKey } = useGetServicepointDetails({
    servicePointId: servicePointNotification?.servicePointId,
    postalCode: matchingAddress?.address.postalCode,
  })

  const invalidateServicePointNotificationQuery = async () =>
    queryClient.invalidateQueries({
      queryKey: getGetServicePointNotificationQueryKey(),
    })

  const handleClose = async () => {
    await acknowledgeServicePointNotification()
    await invalidateServicePointNotificationQuery()

    onDismiss()
  }

  switch (servicePointNotification?.notificationType) {
    case 'closer-than-preference':
      return (
        <CloserByServicePointModal
          addressId={servicePointNotification.addressId}
          open={isOpen}
          onClose={handleClose}
          isLoading={isLoading}
          servicepoint={servicepoint}
          typeKey={typeKey}
        />
      )
    case 'new-in-area':
      return (
        <NewServicePointInAreaModal
          open={isOpen}
          onClose={handleClose}
          isLoading={isLoading}
          servicepoint={servicepoint}
          typeKey={typeKey}
        />
      )
    default:
      return null
  }
}
